import { IServiceFactory } from '../../common/types/service-factory';
import { ContactsApiService, IContactsApiService } from '../services/contacts-api-service';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class ContactsApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IContactsApiService> {
	public Create(): IContactsApiService {
		return new ContactsApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
